import React, { Component } from "react";
import $ from "jquery";

import { connect } from "react-redux";

import { loadMap, updateSize } from "./rds_sisMap";
import { withRouter } from "react-router-dom";
import { FaMapMarkerAlt } from "react-icons/fa";
import stl from "../DefaultLayout/DefaultContents.module.scss";
import "./map.scss";
import * as Service from "services/RestAPI";

class Map extends Component {
	state = {
		sggList: [],
		umdList: [],
		riList: [],
		sanChk: false,
		bobn: "",
		bubn: "",
	};
	componentDidMount() {
		setTimeout(() => {
			// 오늘 날짜 객체 생성
			//const today = new Date();

			// 기간 설정 (월은 0부터 시작하므로 5가 6월, 6이 7월)
			//const start = new Date(2025, 5, 1);   // 2025-06-01
			//const end = new Date(2025, 5, 30, 23, 59, 59, 999); // 2025-06-30 23:59:59

			// 오늘이 기간 내면 실행
			//if (today >= start && today <= end) {
				const modal = this.props.layout.get("surveyModal");
				if (modal) modal.show();
			//}
		}, 0);

		this._getSggList();
		this.props.loadMap({
			id: "map",
			scaleId: "ol-scale",
			zoomSlider: false,
			isCenterPosition: true,
			x: this.props.x,
			y: this.props.y,
			z: this.props.z,
		});

		if (this.props.sis.category) {
			$(`.leftWrap #${this.props.sis.category}`).click();
		}
	}

	// 시군 리스트 가져오기
	_getSggList = async () => {
		await Service.getSggList().then((res) => {
			this.setState({
				sggList: res.data,
			});
		});
	};

	// 읍면동 리스트 가져오기
	_getUmdList = async (regnCode) => {
		await Service.getUmdList(regnCode).then((res) => {
			this.setState({
				umdList: res.data,
			});
		});
	};


	// 지번 입력
	changeInput = (e) => {
		const { name, value } = e.target;
		this.setState({
			[name]: value,
		});
	};

	// 검색버튼
	handleSubmit = () => {
		const { SisMapActions } = this.props;

		let pnu = "";

		const sgg = $("#sgg option:selected").val();
		const umd = $("#umd option:selected").val();
		
		const sggNm = $("#sgg option:selected").text();
		const emdNm = $("#umd option:selected").text();

		const sanChk = $("#landType option:selected").val();

		const { bobn, bubn } = this.state;

		if (sgg === "0") {
			alert("시군를 선택해 주세요.");
			return;
		}

		if (umd === "0") {
			alert("읍면동을 선택해 주세요.");
			return;
		}

		pnu = umd;

		
		pnu += "00";
		
		if (sanChk === "1") {
			pnu += "1";
		} else if (sanChk === "2") {
			pnu += "2";
		}
		//pnu += sanChk ? "2" : "1";

		if (bobn === "") {
			alert("본번을 입력해 주세요.");
			return;
		}

		pnu += lpad(bobn, 4, "0");
		pnu += lpad(bubn, 4, "0");

		const formatBobnBubn = (bobn, bubn) => {
			return bubn ? `${bobn}-${bubn}` : `${bobn}`;
		};
		const jibun = formatBobnBubn(bobn, bubn);
		//SisMapActions.searchPnu({ pnu, sggNm, emdNm, ri, bobn, bubn });

		//this.props.history.push("/mapMain");
		//this.props.sggNm = sggNm;

		const layout = this.props.layout;
        const modal = layout.get("mapInfoModal");
		//let coordinate;
		modal.show(null, pnu, { sggNm, emdNm, bobn, bubn, jibun }, true);
	};
	
	baseMapHanlder = (evt) => {

		
		const { sisMap } = this.props.sis;

        if ($(evt.target).hasClass("active")) {
            $(evt.target).removeClass("active");
            sisMap.kakaoNone();
          // $("#airphoto input[value=-]")[0].click();
		  	sisMap.kakaoHybrid();
            return;
		} else {
			sisMap.kakaoNone();
			sisMap.kakaoNormal();
		}

       $("#mainAir").removeClass("active");
       $(evt.target).addClass("active");

       /* if (evt.target.id === css.base) {
            sisMap.kakaoNormal();
           // $("#airphoto input[value=-]")[0].click();
          // sisMap.vworldNormal();
        } else {
            sisMap.kakaoHybrid();
            //$("#airphoto input[value=2023]")[0].click();
            //$("#airphoto input[value=-]")[0].click();
        }*/
    };

	roadView = (evt) => {
        //alert("준비중입니다");
        //return;
		const { sisMap } = this.props.sis;

       // this.mapSplit(null, {value: "-"}); // 화면분할 종료
       // this.stopLayerInformation(); // 정보보기 중지
        //this.mapMenuHandlerClear();

        $(evt.target).closest("button").toggleClass("active");

        const visible = sisMap.daumRoadView.getVisible();

        sisMap.daumRoadView.setVisible(!visible);

        if (!visible) {
            var roadviewContainer = document.getElementById("roadViewWrap"); //로드뷰를 표시할 div
            sisMap.roadViewInit(roadviewContainer);

            this.setState({
                roadViewMode: true,
                mapSplit: "one",
            });
        } else {
            this.closeRoadView();

            this.setState({
                roadViewMode: false,
                mapSplit: "one",
            });
        }
    };
	toggleMapSearch = (collapsed) => {
		this.setState({ isMapSearchCollapsed: collapsed });
	};

	// 홈페이지 이동
	homePageMove = (target) => {
		//window.location.href = "/mapMain"
		//const history = useHistory();
		this.props.history.push({
			pathname : "/mapMain", 
			state : { aboutProps: "realEstate"}
		});
	};

    // 로드뷰 닫기
    closeRoadView = () => {
        var roadviewContainer = document.getElementById("roadViewWrap");

        $(`.roadViewHidden, .footer`).show();
        $(`.ol-overlaycontainer-stopevent`).show();
        if ($(".toggle").hasClass("close")) $(".toggle").click();
        $("#mapNumber").show();

        $(".sisMapWrap").css({
            top: "64px",
            left: "384px",
            width: "auto",
            height: "auto",
            zIndex: "auto",
            bottom: 0,
            right: 0,
            // display: "inline-flex",
            border: "0",
            transition: "left 0.15s linear",
        });
		$("#map").css({ border: "0" });

        $(".mapRight.menu").show();
        // }

        $(".sisResizable").hide();
        $(".currentArea").show();
        // $(roadviewContainer).hide();

        this.props.sis.sisMap.closeRoadView(roadviewContainer, true);
    };

	smallScreen = () => {
		const { sisMap } = this.props.sis;
		$(".sisMapWrap2 ").css({ height: "380px" });
		$("#" + stl.defaultContents).css({
			height: "1115px"
		});
		sisMap.map.updateSize();
	}
	largeScreen = () => {
		const { sisMap } = this.props.sis;
		$(".sisMapWrap2 ").css({ height: "600px" });
		$("#" + stl.defaultContents).css({
			height: "1340px"
		});
		sisMap.map.updateSize();
	}


	render() {
		return (
			<>
				<div
					className={
						[ 
							this.props.className || "", "map-component", 
							this.state.isMapSearchCollapsed ? "is-search-collapsed" : "",
						]
						.filter(Boolean)
						.join(" ")}
				>
					{/* 실제 지도 */}
					<div id="map" className="map-real">
						<div className="mapNumber">
							<span id="mapNum1">영상1 (2023년)</span>
						</div>
					</div>

					{/* 검색창을 접었을 때 표시되는 버튼 */}
					<button type="button" className="map-search-open" onClick={() => this.toggleMapSearch(false)}>
						부동산 정보조회
					</button>

					{/* 부동산 정보조회 */}
					<form className="map-search" onSubmit={(e) => { e.preventDefault(); this.handleSubmit(); }}>
						<div className="map-search__head">
							<h3>부동산 정보조회</h3>
							<div className="map-search__head-util">
								<button type="button" className="mini-link" onClick={this.homePageMove} >메뉴이동 &gt;
								</button>
								<button type="button" className="map-search__toggle" aria-expanded={!this.state.isMapSearchCollapsed} onClick={() => this.toggleMapSearch(true)} >
									접기
								</button>
							</div>
						</div>

						<div className="map-search__body">
							<fieldset>
								<legend>주소</legend>

								<div className="select-grid select-grid--address">
									<label>
										<span className="sr-only">구 선택</span>
										<select id="sgg" defaultValue="0" onChange={(e) => this._getUmdList(e.target.value)}>
											<option value="0">구명</option>
											{this.state.sggList.map((item) => (
												<option key={item.regnCode} value={item.regnCode} >
													{item.sggNm}
												</option>
											))}
									</select>
									</label>

									<label>
										<span className="sr-only">동 선택</span>

										<select id="umd" defaultValue="0">
											<option value="0">동명</option>

											{this.state.umdList.map((item) => (
												<option key={item.regnCode} value={item.regnCode}>
													{item.umdNm}
												</option>
											))}
									</select>
									</label>

									<label>
										<span className="sr-only">일반 또는 산 선택</span>

										<select id="landType" defaultValue="1">
											<option value="1">일반</option>
											<option value="2">산</option>
									</select>
									</label>
									<input
										id="san"
										name="sanChk"
										type="checkbox"
										checked={this.state.sanChk}
										readOnly
										hidden
									/>
								</div>
							</fieldset>

							<fieldset>
								<legend>지번</legend>

								<div className="select-grid select-grid--parcel">
									<label>
										<span className="sr-only">지번 본번</span>

										<input
											id="bobn"
											type="text"
											name="bobn"
											maxLength="4"
											inputMode="numeric"
											placeholder="본번"
											onChange={this.changeInput}
											onKeyPress={this.handleKeyPress}
										/>
									</label>

									<span className="dash" aria-hidden="true">
										-
									</span>

									<label>
										<span className="sr-only">지번 부번</span>

										<input
											id="bubn"
											type="text"
											name="bubn"
											maxLength="4"
											inputMode="numeric"
											placeholder="부번"
											onChange={this.changeInput}
											onKeyPress={this.handleKeyPress}
										/>
									</label>
								</div>
							</fieldset>

							<button type="submit" className="search-btn">
								검색
							</button>
						</div>
					</form>

					{/* 지도 조작 버튼 */}
					<div className="map-controls">
						<div className="mapSize">
						<div className="viewWrapper">
							<button id="mainAir" type="button" className="active" onClick={this.baseMapHanlder}>
								항공뷰
							</button>
						</div>
							<button
								id="largeScreen"
								type="button"
								onClick={this.largeScreen}
							>
								<img
									src="/sis/images/main/mapup.png"
									alt=""
								/>
								지도확장
							</button>
							<button
								id="smallScreen"
								type="button"
								onClick={this.smallScreen}
							>
								<img
									src="/sis/images/main/mapdown.png"
									alt=""
								/>
								지도축소
							</button>

						</div>
					</div>
				</div>

				
				<div className="sisMapWalker">
					<div className="angleBack"></div>
					<div className="figure"></div>
				</div>

				<div id="searchOverlayWrap">
					<FaMapMarkerAlt size="25" />
					<span id="searchOverlayTitle">타이틀</span>
				</div>
			</>
		);
	}
}

function lpad(str, padLen, padStr) {
	if (padStr.length > padLen) {
		return str;
	}
	str += ""; // 문자로
	padStr += ""; // 문자로
	while (str.length < padLen) str = padStr + str;
	str = str.length >= padLen ? str.substring(0, padLen) : str;
	return str;
}

export default withRouter(connect(
	(state) => ({
		sis: state.sisMap,
		layout: state.layout,
	}),
	(dispatch) => ({
		updateSize: (payload) => dispatch(updateSize(payload)),
		loadMap: (payload) => dispatch(loadMap(payload)),
	})
)(Map));